import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { motion } from 'framer-motion';
import { Mail, Lock, User, ChevronDown, Check, LoaderCircle, Dumbbell, EyeOff, Eye } from 'lucide-react';
import api from '../../services/ApiService';
import { redirectByRole } from '../../constant/redirect';
import logo from '../../assets/images/logo.jpg'
import { ENDPOINTS } from '../../constant/ApiEndpoints';

const ResetPassword = () => {
    const [confirmpassword, setConfirmpassword] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (!confirmpassword || !password) {
            toast.error('Please enter New Password and Confirm Password.');
            return;
        }

        // const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

        if (!passwordRegex.test(password)) {
            toast.error("Password must be at least 8 characters long and include at least one number and one letter.");
            return;
        }
        try {
            setIsLoading(true);
            const response = await api.post(ENDPOINTS.resetPassword, { "password": password });
            const result = response?.data;
            console.log(response);
            console.log(id);

            if (response.status === 200) {
                let token = localStorage.getItem("temptoken");
                localStorage.setItem("authToken", token);
                console.log(id);
                setTimeout(() => {
                    redirectByRole(id, navigate, { message: result?.message || "Password changed successful!" });
                    localStorage.removeItem("temptoken");
                }, 100);
            }
        } catch (error) {
            console.error("Login error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <motion.div
                className="w-full max-w-6xl mx-auto flex flex-col md:flex-row bg-white shadow-2xl rounded-2xl overflow-hidden"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                {/* Left Panel: Form */}
                <div className="w-full md:w-1/2 p-8 sm:p-12 flex flex-col justify-center">
                    <div className="max-w-md mx-auto w-full">
                        <div className="flex items-center gap-3 mb-6">
                            <img src={logo} alt="Logo" width={150} />
                        </div>
                        <h2 className="text-2xl font-bold text-gray-800 mb-2 font-display">Reset Password</h2>
                        {/* <p className="text-gray-500 mb-8">Login to access your dashboard.</p> */}
                        <form onSubmit={handleResetPassword} className="space-y-6">

                            <div className="relative">
                                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="New Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-red/50 focus:border-brand-red outline-none transition-all"
                                    required
                                />
                                <button

                                    type="button"
                                    onClick={() => setShowPassword(prev => !prev)}
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400"
                                >
                                    {showPassword ? (
                                        <EyeOff className="h-5 w-5" />
                                    ) : (
                                        <Eye className="h-5 w-5" />
                                    )}
                                </button>
                            </div>
                            <div className="relative">
                                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    value={confirmpassword}
                                    onChange={(e) => setConfirmpassword(e.target.value)}
                                    className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-red/50 focus:border-brand-red outline-none transition-all"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowConfirmPassword(prev => !prev)}
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400"
                                >
                                    {showConfirmPassword ? (
                                        <EyeOff className="h-5 w-5" />
                                    ) : (
                                        <Eye className="h-5 w-5" />
                                    )}
                                </button>
                            </div>

                            <motion.button
                                whileTap={{ scale: 0.95 }}
                                type="submit"
                                disabled={isLoading}
                                className="w-full bg-brand-red text-white py-3 rounded-lg font-semibold text-lg hover:bg-red-600 focus:outline-none focus:ring-4 focus:ring-brand-red/50 transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                            >
                                {isLoading ? (
                                    <>
                                        <LoaderCircle className="animate-spin h-6 w-6" />
                                        Authenticating...
                                    </>
                                ) : (
                                    'Continue'
                                )}
                            </motion.button>
                        </form>
                    </div>
                </div>

                {/* Right Panel: Image */}
                <div className="hidden md:block md:w-1/2">
                    <div className="h-full w-full bg-cover bg-center" style={{ backgroundImage: "url('../public/gym-image.jpg')" }}>
                        <div className="h-full w-full bg-black/50"></div>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default ResetPassword;
